import CoreInstance from '../CoreInstance';
import centers from './centers';
import groups from './groups';
import babies from './babies';
import activity from './activities';
import dap from './dap';
import assessments from './assessments';
import creditCards from './creditCards';
import subscriptions from './subscriptions';
import catalog from './catalog';
import uploadActivity from './uploadActivity';
import customCollections from './customCollection';
import materials from './materials';
import resources from './resources';
import common from './common';

const CoreApi = {
  CoreInstance,
  organizationScope: {
    ...centers.organizations,
    ...groups.organizations,
    ...babies.organizations,
    ...activity.organizations,
    ...dap.organizations,
    ...assessments.organizations,
    ...subscriptions.subscriptions,
    ...creditCards.creditCards,
  },
  centerScope: {
    ...centers.centers,
    ...groups.centers,
    ...babies.centers,
    ...activity.centers,
    ...dap.centers,
    ...assessments.centers,
    ...catalog.centers,
    ...uploadActivity,
    ...customCollections,
    ...common,
    ...materials.centers,
    ...resources.centers,
  },
};

export default CoreApi;
